/**
 * font
 */
export enum CFont  {
  /**
   * 16点阵
   */
  TSS16,
  /**
   * 20点阵
   */
  TSS20,
  /**
   * 20点阵放大一倍
   */
  TSS20_MAX1,
  /**
   * 24点阵
   */
  TSS24,
  /**
   * 32点阵
   */
  TSS32,
  /**
   * 24点阵放大一倍
   */
  TSS24_MAX1,
  /**
   * 32点阵放大一倍
   */
  TSS32_MAX1,
  /**
   * 24点阵放大两倍
   */
  TSS24_MAX2,
  /**
   * 32点阵放大两倍
   */
  TSS32_MAX2,

  /**
   * 28点阵放大一倍
   */
  TSS28_MAX1,

}
